<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>chargement</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important" variant="warning"></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-row style="height:40vh;margin:0" class="welcome-picture">
        <b-col cols="1" sm="2"></b-col>
        <b-col cols="10" sm="8" style="height:100%">
          <div class="language">
            <template>
              <b-dropdown left split text="language" 
                class="language-dropdown-white" 
                toggle-class="toggle-language-white" 
                split-class="split-language-white" 
                style="font-size: 12px;"
              >
                <template #button-content>
                  <img
                    :src="currentLanguageFlag"
                    style="width:28px; height:19px; border-radius:2px;"
                  >
                </template>>

                <!-- Dropdown Items -->
                <b-dropdown-item @click="selectLanguage('en')">
                  <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                  English
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('fr')">
                  <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                  Français (French)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('de')">
                  <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                  Deutsch (German)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('es')">
                  <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                  Español (Spanish)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('it')">
                  <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                  Italiano (Italian)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('nl')">
                  <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                  Nederlands (Dutch)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('pt')">
                  <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                  Português (Portuguese)
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </div>          
          <div class="welcome-overlay">
            <h1 class="main-title"><span style="color: rgb(195,147,130)">WYNE</span>LOVER</h1>
            <p class="main-subtitle">créé par des amateurs de vin – pour des amateurs de vin</p>
          </div> 
        </b-col>
      </b-row> 
      <b-row>
        <b-col cols="1" sm="2"></b-col>
        <b-col cols="10" sm="8">
          <p class="w-title">Nous sommes un groupe de passionnés de vin.</p>
          <p class="w-text">Notre mission est d’améliorer l’expérience numérique autour du vin de manière ouverte et non commerciale. C’est pourquoi nous avons créé <b>WyneLover</b>.</p>
          <p class="w-text">Dans une première phase, nous développons une trilogie d’applications en ligne interconnectées : WyneMaker, WyneCellar & WyneTaster.</p>

          <b-row>
            <b-col sm="3">
              <p class="w-text text-left">
                <a style="color: rgb(112,112,112)" href="http://www.wynemaker.com"><b>www.wynemaker.com</b></a>
              </p>
            </b-col>
            <b-col>
              <p class="w-text text-left">Pour que les producteurs de vin puissent partager des informations détaillées sur leur domaine et leurs vins.</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <p class="w-text text-left">
                <a style="color: rgb(112,112,112)" href="http://www.wynecellar.com"><b>www.wynecellar.com</b></a>
              </p>
            </b-col>
            <b-col>
              <p class="w-text text-left">Pour que les amateurs de vin puissent gérer et organiser leur cave personnelle.</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <p class="w-text text-left">
                <a style="color: rgb(112,112,112)" href="http://www.wynetaster.com"><b>www.wynetaster.com</b></a>
              </p>
            </b-col>
            <b-col>
              <p class="w-text text-left">Pour organiser ou participer à des événements de dégustation de vin, et gérer vos notes de dégustation.</p>
            </b-col>
          </b-row>

          <p class="w-text">Une fois que la base de données WyneDatabase sera suffisamment alimentée par les producteurs utilisant l'application WyneMaker, nous avons pour objectif de la partager avec le monde entier via une API ouverte — au bénéfice des amateurs de vin, des professionnels et des développeurs.</p>
          
          <hr>

          <p class="w-title">Comment pouvez-vous nous aider ?</p>
          <p class="w-subtitle">Soutien actif.</p>
          <p class="w-text">Nous recherchons des bénévoles passionnés, possédant un large éventail de compétences, pour nous aider à finaliser et à promouvoir le projet :</p>
          <p class="w-text" style="margin:15px">&#9642; marketing et communication</p>
          <p class="w-text" style="margin:15px">&#9642; connaissances en œnologie (locales ou générales)</p>
          <p class="w-text" style="margin:15px">&#9642; design web, UI/UX</p>
          <p class="w-text" style="margin:15px">&#9642; compétences linguistiques et interculturelles</p>
          <p class="w-text" style="margin:15px">&#9642; contacts avec des producteurs de vin, associations, journalistes ou magazines spécialisés</p>
          <p class="w-text">Si l’idée de contribuer à l’avenir numérique du vin vous enthousiasme, et que vous souhaitez rejoindre notre équipe de bénévoles, nous serions ravis de vous accueillir.</p>
          <p class="w-text">Intéressé(e) par le rôle de <b>WyneBassador</b> ?</p>
          <p class="w-text">Envoyez-nous un email à <b>admin@wynelover.com</b> en précisant les compétences que vous pouvez apporter au projet.</p>
          
          <p class="w-subtitle">Soutien passif.</p>
          <p class="w-text">Nous nous engageons à garder ce projet ouvert et non commercial. Cela signifie que nous dépendons entièrement des dons. Si vous aimez ce que nous construisons et souhaitez nous soutenir, veuillez cliquer sur le bouton faire un don ci-dessous.</p>

          <hr>

          <b-row>
            <b-col class="text-left">
              <b-button v-on:click="onBack()" class="w-button-pink">retour</b-button>
            </b-col>
            <b-col class="text-right">
              <b-button v-on:click="onDonate()" class="w-button-green">faire un don</b-button>
            </b-col>
          </b-row>
          <br>    
        </b-col>
      </b-row>
      <br>  
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WineryWelcome',
     computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentUserID() {
        return this.$store.state.user_id
      },
      currentUser() {
        return this.$store.state.user
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },  
      currentProfilePicture() {
        return this.$store.state.profile_picture
      },
      previousPage() {
        return this.$store.state.previous_page
      },
    },
    data() {
      return {
        debug: false, 
        isLoading: true,
      }
    }, 
    mounted() {
      this.isLoading = false
    },
    methods: {
      onBack() {
        this.$store.commit('setPage','Index')
        this.$router.push({path:'/'} );
      },
      onDonate() {
        window.open('https://www.paypal.com/donate/?hosted_button_id=968LLYKG8YBP6');
      },
      
      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("Login.selectLanguage: START");
        this.language = language
        this.$store.commit('setLanguage',language)

        if (local_debug || this.debug) console.log("Login.selectLanguage: language set to ", language);

        if (local_debug || this.debug) console.log("Login.selectLanguage: STOP");
      }, 

      translate(string) {
        // console.log("TMP string: ", string, " language: ", this.currentLanguage, " translation: ",translate_word(string, this.currentLanguage) )
        return translate_word(string, this.currentLanguage);
      },
    }
  }
</script>

<style>
@import url("../../assets/styles/wynestyle.css");
</style>

<style scoped>
.welcome-picture {
    width:100vw;
    height:auto;
    
    background-image: url("../../assets/img/header.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    position:relative;
}
.welcome-overlay {
  width:100%;
  max-width: none !important; 
  position: relative;
  top: 10vh;
}

.language {
  position: fixed;
  top: 5px;
  left: 5px;
  color: white;
  z-index: 10;
}
</style> 